//This is a list of supported image types we allow to upload in the application.
//Any other image type will be blocked
//If this list is modified, modify it on the backend as well
export const supportedImageTypes = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/tiff",
  "image/bmp",
];

// HEIC/HEIF is deliberately not supported on web - only the mobile app handles it
export const supportedImageTypesWithExtensions = [
  ...supportedImageTypes,
  ".jpg",
  ".jpeg",
  ".png",
  ".webp",
  ".tiff",
  ".bmp",
];

//Used to show a dedicated error when someone tries to upload a HEIC/HEIF photo.
//Checks the extension too, since Windows reports a blank or generic MIME type for them
export const isHeicFile = (file) => {
  const ext = file?.name?.split(".").pop()?.toLowerCase();
  return (
    ["heic", "heif"].includes(ext) ||
    ["image/heic", "image/heif"].includes(file?.type)
  );
};

//This is used for general file uploading
export const supportedFileTypes = [
  // Images
  "image/jpeg",
  "image/jpg",
  "image/png",
  "image/webp",
  "image/tiff",
  "image/bmp",
  // Word
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  // Excel
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  // PowerPoint
  "application/vnd.ms-powerpoint",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  // PDF
  "application/pdf",
  // Plain text
  "text/plain",
  "text/csv",
  "application/rtf",
  // OpenDocument (LibreOffice / Linux)
  "application/vnd.oasis.opendocument.text", // odt
  "application/vnd.oasis.opendocument.spreadsheet", // ods
  "application/vnd.oasis.opendocument.presentation", // odp
];

export const spreadsheetTypes = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

//This is used for image uploads of the supported image types
export const maxImageUploadSize = 52428800; //This size is in bytes

//Used for file uploads like word, csv, pdf etc.
export const maxFileUploadSize = 5242880; //This size is in bytes
